module.exports = __webpack_public_path__ + "img/hero-04.ca1462c8.jpg";